import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../../context/ConfigContext';
import { UserInfo } from '../../../interfaces/user';
import SectionHeader from '../ArticlesDiscountSection/SectionHeader/SectionHeader';
import styles from './UserProfileSection.module.scss';

interface UserProfileSectionProps {
  userInfo: UserInfo | null;
}

interface CardData {
  id: string;
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  onPress: () => void;
}

const UserProfileSection: React.FC<UserProfileSectionProps> = ({ userInfo }) => {
  const { config } = useConfig();
    const navigate = useNavigate();

  const primaryColor = config?.primaryColor || '#007AFF';

  const handleOrdersPress = (): void => {
    navigate('mes-commandes');
  };

  const handleProfilePress = (): void => {
    if (userInfo) {
      navigate('mon-profile');
    } else {
      navigate('Authentification');
    }
  };

  const cards: CardData[] = [
    {
      id: 'orders',
      title: 'Mes Commandes',
      subtitle: 'Historique & suivi',
      icon: <ShoppingBagIcon sx={{ fontSize: 24, color: primaryColor }} />,
      onPress: handleOrdersPress,
    },
    {
      id: 'profile',
      title: 'Mon Profil',
      subtitle: 'Informations personnelles',
      icon: <PersonIcon sx={{ fontSize: 24, color: primaryColor }} />,
      onPress: handleProfilePress,
    },
  ];

  return (
    <div className={styles.profileContainer}>
      <SectionHeader title="Mon Espace Client" iconName="person" />

      <div className={styles.cardsContainer}>
        {cards.map((card) => (
          <button
            key={card.id}
            className={styles.card}
            onClick={card.onPress}
            type="button"
          >
            <div className={styles.cardIconContainer}>{card.icon}</div>
            <span className={styles.cardTitle}>{card.title}</span>
            <span className={styles.cardSubtitle}>{card.subtitle}</span>
            <div className={styles.cardArrow}>
              <ChevronRightIcon sx={{ fontSize: 20, color: '#9CA3AF' }} />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default UserProfileSection;